/* eslint-disable */
/*!
   _____ ______ __  __ _    _  _____ __  __ ______ _____  
  / ____|  ____|  \/  | |  | |/ ____|  \/  |  ____|  __ \ 
 | |  __| |__  | \  / | |__| | (___ | \  / | |__  | |  | |
 | | |_ |  __| | |\/| |  __  |\___ \| |\/| |  __| | |  | |
 | |__| | |____| |  | | |  | |____) | |  | | |____| |__| |
  \_____|______|_|  |_|_|  |_|_____/|_|  |_|______|_____/                                                                                                                                                                                                                                                                                                   
=========================================================
* GEMHSMED UI - v2.0.0
=========================================================

* Copyright 2024 GEMHS (https://gemhs.net/)

* Designed and Coded by GEMHS

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 

*/

import React, { useState } from "react";
import {
    Box,
    Flex,
    Switch,
    Text,
    Select,
    useColorMode,
    useColorModeValue,
    VStack,
} from "@chakra-ui/react";
import { SunIcon, MoonIcon } from "@chakra-ui/icons";

const Settings = () => {
    const { colorMode, toggleColorMode } = useColorMode();
    const [language, setLanguage] = useState("en");

    const handleLanguageChange = (event) => setLanguage(event.target.value);

    const themeIcon = colorMode === "light" ? <MoonIcon /> : <SunIcon />;
    const textColor = useColorModeValue("gray.700", "gray.200");

    return (
        <Box
            pt={{ base: "130px", md: "80px", xl: "80px" }}
            px={{ base: "20px", md: "40px", xl: "60px" }}
        >
            <VStack spacing={5}
                align="stretch"
                maxW="600px"
                mx="auto"
                textAlign="center">
                {/* Theme Toggle */}
                <Flex
                    align="center"
                    justify="space-between"
                    mb="30px"
                    p="20px"
                    bg={useColorModeValue("gray.100", "gray.700")}
                    borderRadius="md"
                    shadow="md"
                >
                    <Flex align="center">{themeIcon}</Flex>
                    <Switch
                        isChecked={colorMode === "dark"}
                        onChange={toggleColorMode}
                    />
                </Flex>

                {/* TODO: Language Selector */}
                <Flex
                    direction="column"
                    p="20px"
                    bg={useColorModeValue("gray.100", "gray.700")}
                    borderRadius="md"
                    shadow="md"
                >
                    <Text fontWeight="bold" color={textColor} mb="10px">
                        Language
                    </Text>
                    <Select
                        value={language}
                        onChange={handleLanguageChange}
                        color={textColor}
                        bg={useColorModeValue("white", "gray.800")}
                        borderColor={useColorModeValue("gray.300", "gray.600")}
                        borderRadius="md"
                    >
                        <option value="en">English</option>
                        <option value="es">Spanish</option>
                        <option value="fr">French</option>
                        {/* Add more language options as needed */}
                    </Select>
                </Flex>
            </VStack>
        </Box>
    );
};

export default Settings;
